<template>
	<div>
		<div v-if="hasItens">
			<v-data-table
				:headers="colunas"
				:items="datasource"
				:loading="carregando"
				hide-default-header
				hide-default-footer
				class="arp-listview row-pointer listagem-com-rowspan"
			>
				<template #header>
					<thead>
						<tr>
							<th
								v-for="header in colunas"
								:key="header.text"
								class="v-data-table-header-cell primary--text"
								:class="{
									'v-data-table__mobile-header': header.mobileHidden,
									'text-xs-left': header.align === 'left',
									'text-xs-right': header.align === 'right',
									'text-xs-center': header.align === 'center',
								}"
								:style="{
									width: header.width,
									'min-width': header.minWidth,
									'max-width': header.maxWidth,
								}"
							>
								{{ header.text }}
							</th>
						</tr>
					</thead>
				</template>
				<template #item="{ item, index }">
					<template v-for="(alteracao, indexAlteracao) in item.alteracoes">
						<tr
							class="listagem-rowspan-tr"
							:class="getRowspanClassLastIndex(index, item)"
							:key="alteracao.idHistoricoJustificativa"
						>
							<td :class="getRowspanClassLastItem(indexAlteracao, item)">
								{{ alteracao.classificacaoDe }}° Lugar
							</td>
							<td :class="getRowspanClassLastItem(indexAlteracao, item)">
								{{ alteracao.classificacaoPara }}° Lugar
							</td>
							<td :class="getRowspanClassLastItem(indexAlteracao, item)">
								<texto-tooltip
									:texto="alteracao.nomeFornecedor"
									:tamanho-maximo="textoFornecedorLimite"
								></texto-tooltip>
							</td>
							<template v-if="indexAlteracao === 0">
								<td
									class="listagem-rowspan-child"
									:class="{ 'first-row': index === 0, 'last-row': index === datasource.length - 1 }"
									:rowspan="item.alteracoes.length"
								>
									{{ item.data | azDate }}
								</td>
								<td
									class="listagem-rowspan-child"
									:class="{ 'first-row': index === 0, 'last-row': index === datasource.length - 1 }"
									:rowspan="item.alteracoes.length"
								>
									<texto-tooltip
										:texto="item.justificativa"
										:tamanho-maximo="textoJustificativaLimite"
									></texto-tooltip>
								</td>
							</template>
						</tr>
					</template>
				</template>
			</v-data-table>
			<paginacao-tabela
				:total-paginas="totalPaginas"
				:total-itens="totalItens"
				:page.sync="paginacao.page"
				:rows-per-page.sync="paginacao.rowsPerPage"
				@resetar-page="$emit('reset-page')"
				@paginar="setPaginacaoHistorico"
				class="py-1"
			>
			</paginacao-tabela>
		</div>
		<template-listagem-vazia :textos="textos" :total-itens="totalItens" class="py-1">></template-listagem-vazia>
	</div>
</template>

<script>
import { mutationTypes } from '@/core/constants'
import { mapState } from 'vuex'

export default {
	name: 'historico-alteracao-classificacao',
	data() {
		return {
			colunas: [
				{
					text: 'De',
				},
				{
					text: 'Para',
				},
				{
					text: 'Fornecedor',
				},
				{ text: 'Data', value: 'data', width: '25%' },
				{ text: 'Motivo', value: 'justificativa', width: '25%' },
			],
			carregando: false,
			textos: {
				titulo: 'Não há históricos por aqui',
			},
			textoFornecedorLimite: 70,
			textoJustificativaLimite: 100,
		}
	},
	computed: {
		...mapState({
			paginacao: (state) => state.itemAta.alterarClassificacao.historico.paginacao,
			datasource: (state) => state.itemAta.alterarClassificacao.historico.datasource,
			totalItens: (state) => state.itemAta.alterarClassificacao.historico.totalElements,
			totalPaginas: (state) => state.itemAta.alterarClassificacao.historico.totalPages,
		}),
		hasItens() {
			return this.totalItens > 0
		},
	},
	watch: {
		paginacao: {
			handler(novoValor) {
				this.setPaginacaoHistorico(novoValor)
			},
			deep: true,
		},
	},
	beforeDestroy() {
		this.$store.commit(mutationTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.HISTORICO.RESETAR_PAGINA_LISTAGEM)
	},
	async mounted() {
		this.carregando = true
		await this.$emit('carregar-historico')
		this.carregando = false
	},
	methods: {
		async setPaginacaoHistorico(paginacao) {
			this.$store.commit(mutationTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.HISTORICO.SET_PAGINACAO_LISTAGEM, paginacao)
			await this.$emit('carregar-historico')
		},
		getRowspanClassLastIndex(index, item) {
			const indexAlteracao = item.alteracoes.length - 1

			return {
				'listagem-rowspan-tr-last-index':
					index === this.datasource.length - 1 && indexAlteracao === item.alteracoes.length - 1,
			}
		},
		getRowspanClassLastItem(index, item) {
			return {
				'listagem-rowspan-td-last': index === item.alteracoes.length - 1,
			}
		},
	},
}
</script>
<style lang="stylus" scoped>
.listagem-com-rowspan {
	.thead {
		background-color #f1f1f1
		font-weight bold
	}

	.v-data-table-header-cell {
		padding 0 8px !important
		vertical-align middle !important
		font-weight 600 !important
	}

	.first-row {
		border-top: none !important
	}

	.listagem-rowspan-child {
		border-style solid
		border-width 1px
		border-top-color rgba(0, 0, 0, .12) !important
		border-left-color rgba(0, 0, 0, .12) !important
		border-bottom-color rgba(0, 0, 0, .12) !important
		border-right none
		word-break: break-word !important
	}

	td {
		border-bottom 1px solid rgba(0, 0, 0, .12) !important
	}

	td:not(.listagem-rowspan-td-last, .last-row) {
		border-bottom none !important
	}

	.listagem-rowspan-tr-last-index > td {
		border-bottom 1px solid rgba(0, 0, 0, .12) !important
	}
}

.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
	background none !important
}
</style>
